import { useEffect, useRef } from "react";

let nextHookId = 0;
let baseTitle = null;
const titleStack = [];

function syncDocumentTitle() {
  if (titleStack.length > 0) {
    document.title = titleStack[titleStack.length - 1].title;
    return;
  }

  if (baseTitle !== null) {
    document.title = baseTitle;
    baseTitle = null;
  }
}

export function useDocumentTitle(title) {
  const hookIdRef = useRef(null);

  if (hookIdRef.current === null) {
    hookIdRef.current = ++nextHookId;
  }

  useEffect(() => {
    if (titleStack.length === 0) {
      baseTitle = document.title;
    }

    titleStack.push({ id: hookIdRef.current, title });
    syncDocumentTitle();

    return () => {
      const hookIndex = titleStack.findIndex(
        (entry) => entry.id === hookIdRef.current
      );
      if (hookIndex !== -1) {
        titleStack.splice(hookIndex, 1);
      }

      syncDocumentTitle();
    };
  }, []);

  useEffect(() => {
    const hookIndex = titleStack.findIndex(
      (entry) => entry.id === hookIdRef.current
    );
    if (hookIndex === -1) return;

    titleStack[hookIndex].title = title;
    syncDocumentTitle();
  }, [title]);
}
